import { render, staticRenderFns } from "./lectionCla.vue?vue&type=template&id=61119fb2&"
import script from "./lectionCla.vue?vue&type=script&lang=js&"
export * from "./lectionCla.vue?vue&type=script&lang=js&"
import style0 from "./lectionCla.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports